export const setupImageSliders = (): void => {
  const imageSliders = document.querySelectorAll<HTMLElement>("[data-image-slider-container]");
  if (!imageSliders) return;

  imageSliders.forEach(setupImageSlider);
};

const setupImageSlider = (slider: HTMLElement): void => {
  const mainImages = slider.querySelectorAll<HTMLElement>("[data-image-slider-main]");
  const scrollContainer = slider.querySelector<HTMLElement>("[data-image-slider-scroll]");
  const thumbnails = slider.querySelectorAll<HTMLElement>("[data-image-slider-thumbnail]");
  const nextButton = slider.querySelector<HTMLElement>("[data-image-slider-next]");
  const prevButton = slider.querySelector<HTMLElement>("[data-image-slider-prev]");

  if (!scrollContainer) return;

  let scrollTimer: NodeJS.Timeout | null; //nodejs timeout is created for using interval
  let currentIndex = 0;


  const stopScrolling = () => {
      if (scrollTimer) {
          clearInterval(scrollTimer);
          scrollTimer = null;
      }
  };

  // Helper: Scroll to a specific thumbnail smoothly
  const smoothScrollToThumbnail = (thumbnail: HTMLElement) => {
      const containerCenter = scrollContainer.getBoundingClientRect().left + scrollContainer.offsetWidth * 0.5;
      const thumbnailCenter = thumbnail.getBoundingClientRect().left + thumbnail.offsetWidth * 0.5;
      const scrollByValue = thumbnailCenter - containerCenter;

      scrollContainer.scrollBy({ left: scrollByValue, behavior: "smooth" });
      stopScrolling();
  };

  // Update the main image and highlight the active thumbnail
  const updateSlider = () => {
      //Main images only appear on desktop.
      if(mainImages)
      {
          mainImages.forEach((image, index) => {
              image.classList.toggle("hidden", index !== currentIndex);
          });
      }

      let isActive = false;
      thumbnails.forEach((thumbnail, index) => {
          isActive = index === currentIndex;
          thumbnail.classList.toggle("active", isActive);
          if (isActive)
          {
              smoothScrollToThumbnail(thumbnail);
          } 
      });
  };

  // Event Handlers
  const handleThumbnailClick = (thumbnail: HTMLElement, index: number) => {
      thumbnail.addEventListener("click", () => {
          currentIndex = index;
          updateSlider();
      });
  };

  const handleNavigation = (direction: number) => {
      if(mainImages.length > 0)
      {
          currentIndex = (currentIndex + direction + mainImages.length) % mainImages.length;
      }
      else
      {
          currentIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
      }
      updateSlider();
  };

  // Attach Event Listeners
  thumbnails.forEach((thumbnail, index) => handleThumbnailClick(thumbnail, index));

  prevButton?.addEventListener("click" , () => handleNavigation(-1));
  nextButton?.addEventListener("click" , () => handleNavigation(1));


  // Initialize slider
  updateSlider();
};
